import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="bg-stone-950 text-stone-50 py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-47">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-amber-900/10 blur-[120px] pointer-events-none" data-id="element-48" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-49">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-50">
          <FadeIn data-id="element-51">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 text-stone-50 tracking-tight" data-id="element-52">
              Dile adiós a la rigidez:{' '}
              <span className="text-amber-500" data-id="element-53">
                El Método de 10 Minutos para Despertar Sin Dolor Articular
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-stone-300 mb-10 leading-relaxed" data-id="element-54">
              Recupera la movilidad de tus 30s y levántate de la cama con
              agilidad, sin depender de pastillas ni sufrir "el primer paso" del
              día.
            </p>
            <Button scrollTo="pricing" data-id="element-55">¡Sí! Quiero Despertar Sin Dolor</Button>
          </FadeIn>

          <FadeIn delay={0.2} className="relative" data-id="element-56">
            <div className="absolute inset-0 bg-gradient-to-tr from-amber-600/20 to-transparent rounded-2xl transform rotate-3 scale-105" data-id="element-57" />
            <img src="https://cdn.magicpatterns.com/uploads/ogM2PAgokvDNRtwF3vk6Tf/IMAGEN.png" alt="Despertar Sin Dolor en Tablet" className="relative z-10 w-full rounded-2xl shadow-2xl border border-stone-800" data-id="element-58" />
          </FadeIn>
        </div>
      </div>
    </section>;
}